import { EngineTheme } from '@websky/core/src/theme';
import Shared from './components/Shared';

const themeShared: EngineTheme = {
	Counter: {
		Counter: {
			button: Shared.Button.counter_button,
			value: Shared.Counter.value,
			counter: Shared.Counter.counter,
			button_disabled: Shared.Button.button_disabled
		}
	},

	CloseIcon: {
		CloseIcon: {
			wrapper: Shared.CloseIcon.popup_wrapper
		}
	},
	Button: {
		ActionButton: {
			button: Shared.Button.primary
		}
	}
};

export default themeShared;
